import React, { Fragment, useState, useEffect } from 'react'
import { usePrevious } from '../../util/hooks'
// import { __ } from '@wordpress/i18n'
// import pages from 'scripts/shared/pages'
import PropTypes from 'prop-types'
import Button from '../Button/component'
import FilterChips from '../FilterChips'
import { trackGtmEvent } from 'scripts/util/tracking'
import './styles.scss'

const AddSearchAgent = ({
  filterChips,
  isAdding,
  locationAndObjektartIsSet,
  addSearchAgent,
  vermarktungsart,
}) => {
  const [showSuccess, setShowSuccess] = useState(false)
  const prevIsAdding = usePrevious(isAdding)

  useEffect(() => {
    if (prevIsAdding) {
      setShowSuccess(true)
    }
  }, [isAdding])

  const saveSucheClick = type => {
    trackGtmEvent(
      `suche-suchauftrag-${
        type == 'kauf' ? `${type}-anlegen` : `anlegen-${type}`
      }`
    )
    addSearchAgent()
  }

  return (
    <div className="dhsv_add_search_agent">
      {showSuccess && (
        <div className={`dhsv_success_message`}>
          <p>
            Ihr Suchauftrag <strong>{filterChips.location}</strong> wurde
            erfolgreich angelegt
          </p>
        </div>
      )}
      {!showSuccess && (
        <div>
          {locationAndObjektartIsSet ? (
            <Fragment>
              <p>
                Speichern Sie Ihre Suche und erhalten Sie per E-Mail neue
                Angebote für
              </p>
              <FilterChips unremovable={true} />
              <Button
                style="primary"
                icon
                callback={() => saveSucheClick(vermarktungsart)}
                loading={isAdding}
              >
                Suche speichern
              </Button>
            </Fragment>
          ) : (
            <Fragment>
              <p className="h4">Wollen Sie die aktuelle Suche speichern?</p>
              <p>
                Zur Anlage eines Suchauftrages geben Sie bitte PLZ/ Ort und
                Objektart an.
              </p>
            </Fragment>
          )}
        </div>
      )}
      {/*<Button*/}
      {/*  url={`${pages.user_profile.link}/suchende/suchauftrage`}*/}
      {/*  style="primary"*/}
      {/*  icon*/}
      {/*>*/}
      {/*  {__('Alle Suchagenten', 'dhsv_theme')}*/}
      {/*</Button>*/}
    </div>
  )
}

AddSearchAgent.propTypes = {
  browser: PropTypes.object,
  filterChips: PropTypes.object,
  isAdding: PropTypes.bool,
  locationAndObjektartIsSet: PropTypes.bool,
  addSearchAgent: PropTypes.func,
  close: PropTypes.func,
  vermarktungsart: PropTypes.string,
}

export default AddSearchAgent
